module.exports = __webpack_public_path__ + "static/media/02-eCSPlus-bk_4x.6456cd94.png";